import { useEffect, useState } from "react";
import { TrendingUp, ShoppingBag, RefreshCcw, Users } from "lucide-react";
import api from "../lib/api";

const euro = (n) => `€${Number(n).toFixed(2).replace(".", ",")}`;

export const AdminStats = ({ onCardClick }) => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/stats").then(({ data }) => setStats(data)).catch(() => {});
  }, []);

  if (!stats) return null;

  const cards = [
    { icon: TrendingUp, label: "Incasso totale", value: euro(stats.revenue), testid: "stat-revenue", target: "incassi" },
    { icon: ShoppingBag, label: "Ordini", value: stats.orders, testid: "stat-orders", target: "ordini" },
    { icon: RefreshCcw, label: "Abbonamenti attivi", value: stats.active_subs, testid: "stat-subs", target: "clienti" },
    { icon: Users, label: "Clienti", value: stats.customers, testid: "stat-customers", target: "clienti" },
  ];

  return (
    <section className="mb-6" data-testid="admin-dashboard">
      <h2 className="mb-4 font-serif text-2xl font-light text-ink">Dashboard</h2>
      <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
        {cards.map(({ icon: Icon, label, value, testid, target }) => (
          <button
            key={testid}
            onClick={() => onCardClick?.(target)}
            data-testid={testid}
            className="group rounded-2xl border border-ink/10 bg-panel p-5 text-left transition-all hover:-translate-y-0.5 hover:border-terra/50 hover:shadow-lg"
          >
            <Icon className="mb-3 h-5 w-5 text-terra transition-transform group-hover:scale-110" strokeWidth={1.6} />
            <p className="font-serif text-2xl text-ink md:text-3xl">{value}</p>
            <p className="mt-1 flex items-center justify-between text-xs uppercase tracking-overline text-ink-soft">
              {label}
              <span className="text-[10px] normal-case text-terra opacity-0 transition-opacity group-hover:opacity-100">Vedi →</span>
            </p>
          </button>
        ))}
      </div>
      {stats.top_products?.length > 0 && (
        <div className="mt-3 rounded-2xl border border-ink/10 bg-panel p-5" data-testid="stat-top-products">
          <p className="mb-3 text-xs uppercase tracking-overline text-ink-soft">Prodotti più venduti</p>
          <div className="flex flex-wrap gap-2">
            {stats.top_products.map((t, i) => (
              <span key={t.name} className="rounded-full bg-cream px-3.5 py-1.5 text-sm text-ink" data-testid={`top-product-${i}`}>
                <span className="font-semibold text-terra">{i + 1}.</span> {t.name} <span className="text-ink-soft">×{t.qty}</span>
              </span>
            ))}
          </div>
        </div>
      )}
    </section>
  );
};
